import { Action } from 'redux';
import { updateAction } from '../../utils/utility';
import actionTypes from '../types/mailBoxTypes';

export const fetchPayerList = (): Action<any> => (updateAction(actionTypes.FETCH_PAYER_LIST));

export const saveHospitalPrimaryMailId = (data: any, onSuccess: any, onError: any): Action<any> =>
  updateAction(actionTypes.SAVE_HOSPITAL_PRIMARY_ID, {data, onSuccess, onError});

export const saveHospitalSecondaryMailId = (secondaryMailIdid: any, onSuccess: any, onError: any): Action<any> =>
  updateAction(actionTypes.SAVE_HOSPITAL_SECONDARY_ID, {secondaryMailIdid, onSuccess, onError});

export const updateEmailConfiguration = (payload: any): Action<any> =>
  updateAction(actionTypes.UPDATE_EMAIL_CONFIGURATION, payload);

export const updateHospitalEmailConfiguration = (payload: any): Action<any> =>
  updateAction(actionTypes.UPDATE_HOSPITAL_EMAIL_CONFIGURATION, payload);

export const setEnabledPayer = (enabledPayer: number): Action<any> =>
  updateAction(actionTypes.SELECT_ENABLED_PAYER, enabledPayer);

export const setCenterId = (centerId: number): Action<any> =>
  updateAction(actionTypes.SELECT_CENTER_ID, centerId);

export const updateRpaEmailConfiguration = (payload: any): Action<any> =>
  updateAction(actionTypes.UPDATE_RPA_EMAIL_CONFIGURATION, payload);

export const saveMailBoxEmailConfig = (formData: any, onSuccess: any = (): any => { }, onError: any = (): any => { }): Action<any> => (
  updateAction(actionTypes.SAVE_MAILBOX_EMAIL_CONFIG, { formData, onSuccess, onError })
);

export const getAuthRedirectURL = (): Action<any> =>
  updateAction(actionTypes.GET_AUTH_REDIRECT_URL, {});

export const delayMailBoxConfiguration = (): Action<any> =>
  updateAction(actionTypes.DELAY_MAILBOX_CONFIGURATION);

export const setEnableCheckSwitch = (payload: boolean): Action<any> =>
  updateAction(actionTypes.ENABLE_SWITCH_CHECK, payload);

export const setEmailVerifyModalShow = (payload: boolean): Action<any> =>
  updateAction(actionTypes.SHOW_EMAIL_VERIFY_MODAL, payload);

export const setHospitalSecondaryMailIds = (payload: any[]): Action<any> =>
  updateAction(actionTypes.SET_HOSPITAL_SECONDARY_MAIL_ID, payload);

export const fetchLatestHospitalMailData = (payload: any): Action<any> =>
  updateAction(actionTypes.FETCH_LATEST_HOSPITAL_MAIL_DATA, payload);

export const fetchPayerConfig = (providerId: any, onSuccess: any = (): any => { }, onError: any = (): any => {}): Action<any> => (
  updateAction(actionTypes.FETCH_PAYER_CONFIGURATION, { providerId, onSuccess, onError }));

export const fetchHospitalConfig = (providerId: any, onSuccess: any = (): any => { }, onError: any = (): any => {}): Action<any> => (
  updateAction(actionTypes.FETCH_HOSPITAL_CONFIGURATION, { providerId, onSuccess, onError }));

export const setPayerConfig = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_PAYER_CONFIGURATION, payload);

export const savePayerEnableToggleConfig = (data: any, onSuccess: any = (): any => {}): Action<any> =>
  updateAction(actionTypes.SAVE_PAYER_ENABLE_TOGGLE_CONFIGURATION, {data, onSuccess});

export const savePayerEmailConfig = (data: any, onSuccess: any = (): any => { }, onError: any = (): any => {}): Action<any> =>
  updateAction(actionTypes.SAVE_PAYER_EMAIL_CONFIGURATION, { data, onSuccess, onError });

export const verifyAndSavePortalCredentials = (data: any, Verify: any = (): any => { }, onError: any = (): any => { }): Action<any> =>
  updateAction(actionTypes.VERIFY_AND_SAVE_PORTAL_CREDENTIALS, { data, Verify, onError });

export const saveDepartmentEmailConfig = (data: any, onSuccess: any = (): any => { }, onError: any = (): any => {}): Action<any> =>
  updateAction(actionTypes.SAVE_DEPARTMENT_EMAIL_CONFIGURATION, { data, onSuccess, onError });
